import React, { useEffect } from "react";
import "./Invoice80mm.css";
import { dynamicImage } from "../../../../Service";
import { useParams } from "react-router-dom";
import api from "../../../../utils/api";

const PrintFoodOrder = () => {
  const params = useParams();
  const foodOrderId = params.id || "0";
  const [items, setItems] = React.useState<any[]>([]);
  // const items = [
  //   {
  //     "ticketRFIdRef": "REF-SWP-2311",
  //     "cardNumber": 9090909090,
  //     "customerName": "Roshan Kujur",
  //     "custometMobileNumber": "8347821920",
  //     "gst": 10,
  //     "subTotalAmount": 200,
  //     "grandTotalAmount": 210,
  //     "foodItemName": "TEST ITEM",
  //     "price": 10,
  //     "quantity": 1
  //   },
  //   {
  //     "ticketRFIdRef": "REF-SWP-2311",
  //     "cardNumber": 9090909090,
  //     "customerName": "Roshan Kujur",
  //     "custometMobileNumber": "8347821920",
  //     "gst": 10,
  //     "subTotalAmount": 200,
  //     "grandTotalAmount": 210,
  //     "foodItemName": "TEST ITEM11",
  //     "price": 100,
  //     "quantity": 100
  //   }
  // ];

  const fooddetails = async () => {
    try {
      const res = await api.get(`/api/FoodOrder/FoodBilling?foodOrderId=${foodOrderId}`);
      if (res.status === 200) {
        // Process the response data
        const data = Array.isArray(res.data) ? res.data : [];
        const updatedData = data.map((item: any) => ({
          ...item,
          customerName: item.customerName === null ? "" : item.customerName,
          custometMobileNumber: item.custometMobileNumber === null ? "" : item.custometMobileNumber,
        }));
        setItems(updatedData);
      }
    } catch (error) {
      // console.error("Error fetching food order:", error);
    }
  };


  useEffect(() => {
    fooddetails();
    if (items.length > 0) {
      window.print();
    } else {
      setTimeout(window.print, 1000);
        }
  }, []);
  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      {items.length > 0 && (
        <div className='page-body'>
          <div className="invoice-container">
            <button className="print-button" onClick={handlePrint}>🖨️ Print</button>
            <div className="invoice">
              <div className="logo">
                <img src={dynamicImage("logo/logo.png")} alt="Logo" />
                <h2>SHIVALYA WATER PARK</h2>
              </div>

          <div className="details">
            <p><strong>Ticket No.:</strong> {items[0].ticketRFIdRef}</p>
            <p><strong>RFID Card No.:</strong> {items[0].cardNumber}</p>
            <p><strong>Customer Name:</strong> {items[0].customerName}</p>
            <p><strong>Mobile Number:</strong> {items[0].custometMobileNumber}</p>
          </div>

          <table className="item-table">
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={i}>
                  <td>{item.foodItemName}</td>
                  <td>{item.quantity}</td>
                  <td>Rs {item.price.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="totals">
            <p><strong>Sub Total :</strong> Rs {items[0].subTotalAmount}</p>
            <p><strong>GST :</strong> Rs {items[0].gst}</p>
            <p><strong>Grand Total :</strong> Rs {items[0].grandTotalAmount}</p>
          </div>
        </div>
      </div>
    </div>
      )}
    </>
  );
};

export default PrintFoodOrder;
